import { MessageViewEmodjiDto, MessageViewFileDto } from '@src/api-messenger';

import { ReactionType } from '../reaction';

import { MessageFooterMode } from './message-footer';

export type MessageFileType = MessageViewFileDto;
export interface MessageContentType {
  text?: string;
  files?: MessageFileType[];
  emodji?: Array<MessageViewEmodjiDto>;
}

export type MessageContentTypeEnum = 'text' | 'file' | 'image' | 'emodji' | 'audio' | 'video';
export const MessageContentTypeEnum = {
  Text: 'text' as MessageContentTypeEnum,
  File: 'file' as MessageContentTypeEnum,
  Image: 'image' as MessageContentTypeEnum,
  Emodji: 'emodji' as MessageContentTypeEnum,
  Audio: 'audio' as MessageContentTypeEnum,
  Video: 'video' as MessageContentTypeEnum,
};

export interface MessageModel {
  chatId: string;
  dateCreated: Date;
  id: string;
  content: MessageContentType;
  contentType: MessageContentTypeEnum | null;
  replyMessageId?: string | null;
  replyMessageText?: string | null;
  payload?: string;
  userId: string;
  userName: string;
  deliveredToAnyOne?: boolean;
  readAnyOne?: boolean;
  reactions?: Array<ReactionType> | null;
}

export interface MessageFooterStoreModel {
  mode: MessageFooterMode;
  message: MessageModel;
}
